import { Component, ChangeDetectionStrategy} from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';

@Component({ standalone: false,
    selector: 'irb-checkbox-cell',
    template: `<p-checkbox binary="true" [(ngModel)]="value" (onChange)="onChange()" [disabled]="isDisabled"></p-checkbox>`,
  changeDetection: ChangeDetectionStrategy.Eager
})
export class CheckboxCellComponent implements AgRendererComponent {
    params: any;
    value: boolean;
    isDisabled: boolean;

    constructor() {}

    agInit(params: any) {
        this.params = params;
        this.value = typeof this.params.value === 'boolean' ? this.params.value : false;
        this.isDisabled = typeof this.params.isDisabled === 'boolean' ? this.params.isDisabled : false;
    }

    refresh(): boolean {
        return true;
    }

    onChange() {
        if (this.params.onChange) {
            this.params.onChange(this.value);
        }
    }
}
